import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useEffect } from "react";
export default function SuccessfullPayment() {

	useEffect(()=>{
	},[])
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Typography
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 22,
          color: "secondary.main",
          fontFamily: "ProximaNovaSoftSemibold",
        }}
      >
        Payment Successful
        <CheckCircleIcon sx={{ color: "success.main", mx: 1, fontSize: 100 }} />
      </Typography>

        <Link href={process.env.REACT_APP_MCA_URL} color="primary" sx={{
					fontSize: 18,
					color: "secondary.main",
          fontFamily: "ProximaNovaSoftSemibold",
					border: 1,
					borderRadius: 2,
					p:1
				}} underline="none">
          Open Corelife Application
        </Link>
    </Box>
  );
}
